import { createSelector } from 'reselect';

import { selectActiveVenue, selectActiveVenueId, selectRouteQuery } from 'selectors/general';

import { selectIsDesktop } from 'selectors/ui';
import {
  statsMarketInsightsModulesList as statsMarketInsightsModulesListEntity,
  statsYourInsightsModulesList as statsYourInsightsModulesListEntity,
  statsInsightsModule as statsInsightsModuleEntity,
} from 'store/saga/entities/bound';
import { VENUE_SOURCE } from 'constants/logic';
import {
  DEFAULT_RANGE_WEEKS,
  VALID_RANGES_WEEKS,
  YOUR_INSIGHTS_CATEGORIES_SORTED,
  YOUR_INSIGHTS_MODULE_TYPES_BY_CATEGORY,
} from '../Stats.constants';

export const selectRange = createSelector(
  selectRouteQuery,
  query => VALID_RANGES_WEEKS.find(validRange => validRange === query.range) || DEFAULT_RANGE_WEEKS
);

export const selectMarketInsightsModulesList = createSelector(
  state => state,
  selectActiveVenueId,
  selectIsDesktop,
  (state, activeVenueId, isDesktop) => {
    const modulesList = statsMarketInsightsModulesListEntity.select(state, activeVenueId);
    return {
      data: isDesktop
        ? (modulesList?.data?.modules || []).reduce(
            (acc, curr, i) => {
              acc[i % 2].push(curr);
              return acc;
            },
            [[], []]
          )
        : [modulesList?.data?.modules],
      error: modulesList?.error,
      loaded: modulesList?.loaded,
      loading: modulesList?.loading,
    };
  }
);

export const selectYourInsightsModulesList = createSelector(
  state => state,
  selectActiveVenueId,
  selectIsDesktop,
  (state, activeVenueId, isDesktop) => {
    const modulesList = statsYourInsightsModulesListEntity.select(state, activeVenueId);
    const modulesListCategorized = {};
    YOUR_INSIGHTS_CATEGORIES_SORTED.forEach(category => {
      modulesListCategorized[category] = modulesList?.data?.filter(item =>
        (YOUR_INSIGHTS_MODULE_TYPES_BY_CATEGORY[category] || []).includes(item.module)
      );
    });
    const data = {};
    Object.entries(modulesListCategorized).forEach(([key, value = []]) => {
      data[key] = isDesktop
        ? value.reduce(
            (acc, curr, i) => {
              acc[i % 2].push(curr);
              return acc;
            },
            [[], []]
          )
        : [value];
    });

    return {
      data,
      error: modulesList.error,
      loaded: modulesList.loaded,
      loading: modulesList.loading,
      isCategorized: true,
    };
  }
);

// This selector is generic and is used for both your insights and market insights
export const selectModuleData = createSelector(
  (state, url = '') => [state, url],
  selectRange,
  ([state, url], range) =>
    statsInsightsModuleEntity.select(state, statsInsightsModuleEntity.defaultKey(null, url, range))
);

export const selectExcessInventoryShouldShow = createSelector(
  state => state,
  selectActiveVenue,
  (state, activeVenue) => {
    const { venueSource } = activeVenue;
    return venueSource !== VENUE_SOURCE.MSINVENTORY;
  }
);
